var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-box"},[_c('div',{class:'bottom-bit bottom-bit'+_vm.follow,on:{"click":function($event){return _vm.is_follow(_vm.arr,_vm.follow)}}},[_vm._v(_vm._s(_vm.follow==2?'互相关注':(_vm.follow?'取消关注':'关注')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }